import './InvitedRelativesEmptyState.scss';

import { faPaperPlane, faUserPlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { InviteRelativesButton } from './InviteRelativesButton';

export const InvitedRelativesEmptyState = () => (
  <div className='fvt-invited-empty'>
    <div className='fvt-invited-empty__icon-wrap' aria-hidden='true'>
      <FontAwesomeIcon icon={faUserPlus} />
    </div>
    <h3 id='fvt-invited-card-title' className='fvt-invited-empty__title fw-semibold text-primary'>
      No invitations yet
    </h3>
    <p className='fvt-invited-empty__body text-secondary'>
      Once you invite someone, they&apos;ll appear here. We email each relative privately — no medical details, and your
      name is never shared.
    </p>
    <InviteRelativesButton label='Invite my relatives' icon={faPaperPlane} />
  </div>
);
